<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>G.H. Raisoni Memorial Singruali One Day Open Rapid Chess Tournament 2026 </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="sec-title">
            <h2><span>G.H. Raisoni Memorial Singruali One Day Open Rapid Chess Tournament 2026</span></h2>
        </div>
        <p><strong>Date:</strong> 8th February 2026</p>
        <p><strong>Venue:</strong> Waidan Degree Collage, Singruali MP</p>
        <p><strong>Organized by:</strong> Singruali Chess Association</p>
        <p><strong>Tournament Director:</strong> Mrs Vasundhara Himmatramka, Treasure Singruali Chess Association</p>
        <p><strong>Chief Arbiter:</strong> SNA Vivek Vishwakarma</p>
        <p><strong>Time Control:</strong> 15min + 5 sec Increment from move No 1</p>

        <p>The G. H. Raisoni Memorial Singruali One Day Rapid Chess Championship 2026 was successfully organized on
            8th February 2026. The event aimed to foster teamwork, promote the game of chess among students and youth,
            and provide a professional platform for emerging talents from Singruali and surrounding regions.</p>
        <hr>

        <h5 class="primary-purple">Participation:</h5>
        <p>A total of 114 Players (16 Fide Rated Players) has participated in the championship, representing various
            schools, colleges, and chess academies. Total Prize Fund Fifty-One Thousand but Under-7 & Physically
            handicapped 1&2nd and 3rd Players are not available in tournament Forty-Eight hundred remaining amount
            adjust
            next year tournament. The event followed a Swiss League format of 7 rounds, ensuring every Player got ample
            opportunity to compete and demonstrate their skills.</p>
        <hr>

        <h5 class="primary-purple">Inaugural Session:</h5>
        <p>The tournament was inaugurated by Chief Guest Adani Mining Limited DGM Vikram Sharma in the presence of
            dignitaries, guests, and chess enthusiasts. The chief guest appreciated the organizers efforts in promoting
            sports culture and highlighted the importance of discipline and strategic thinking in chess.</p>
        <hr>

        <h5 class="primary-purple">Conduct of the Event:</h5>
        <p>The Tournament Was Conducted Under the Guidance of Qualified FIDE Arbiters and Officials from the Singruali
            District Chess Association. The matches were managed smoothly, maintaining a professional and fair
            atmosphere
            throughout the event. The venue arrangements, digital pairing display, and live score updates ensured a
            pleasant experience for both players and visitors.</p>
        <hr>
        <h5 class="primary-purple">Prize Distribution:</h5>
        <p>Ceremony The Chief Guest Principal MU Siddiqui & Subhash Bhais, felicitated the winners and participants.
            The ceremony concluded with motivating words that inspired the young players to continue their chess journey
            with passion and dedication.</p>
        <hr>

        <h5 class="primary-purple">Acknowledgments:</h5>
        <p>The success of this event was made possible through the generous support and collaboration of our sponsors
            and partners.</p>
        <p><strong>We express our sincere gratitude to:</strong></p>
        <ul class="list-style list-style1 mb-3 list-count">
            <li><strong>Kalpana Prakash Welfare Foundation & G. H. Raisoni Sports & Cultural Foundation</strong> –
                for their continuous encouragement and sponsorship support.</li>
            <li><strong>Singruali Chess Association</strong> – for granting official recognition and technical
                guidance.</li>
            <li><strong>All Arbiters, Volunteers, and Officials</strong> – for their tireless work ensuring smooth
                conduct of the championship.</li>
            <li><strong>Participants, Parents, and Coaches</strong> – for their enthusiastic participation and
                cooperation.</li>
        </ul>
        <hr>

        <h5 class="primary-purple">Conclusion:</h5>
        <p>The G. H. Raisoni Memorial Open One Day Chess Championship 2026 concluded successfully, achieving its
            objectives of promoting chess and nurturing young talent. The tournament created a platform that combined
            competition, learning, and camaraderie.</p>
        <hr>
        <p>We look forward to organizing more such events with continued support from our esteemed sponsors and
            partners.</p>
        <hr>

        <h5 class="primary-purple">Important Links:</h5>
        <ul class="list-style list-style1 mb-3 ">
            <li><strong>Chess Tournament Link:</strong> <a
                    href="https://s2.chess-results.com/tnr1345714.aspx?lan=1&SNode=S0"
                    target="_blank">https://s2.chess-results.com/tnr1345714.aspx?lan=1&SNode=S0</a></li>
            <li><strong>Starting Rank List of the Players:</strong> <a
                    href="https://s3.chess-results.com/tnr1309563.aspx?lan=1&turdet=YES&SNode=S0"
                    target="_blank">https://s3.chess-results.com/tnr1309563.aspx?lan=1&turdet=YES&SNode=S0</a></li>
            <li><strong>Final Ranking:</strong> <a
                    href="https://s1.chess-results.com/tnr1345714.aspx?lan=1&art=4&SNode=S0"
                    target="_blank">https://s1.chess-results.com/tnr1345714.aspx?lan=1&art=4&SNode=S0</a></li>
        </ul>
        <hr>

        <!-- <div class="col-md-12">
            <div class="sec-title mt-4 text-center">
                <h2><span>Photo Gallery</span></h2>
            </div>
            <div class="lightBox--gallery">
                <ul class="list-unstyled lightgallery justify-content-center row row-cols-2 row-cols-md-3">
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/rapid-blitz-1.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/rapid-blitz-1.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/rapid-blitz-1.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/rapid-blitz-2.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/rapid-blitz-2.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/rapid-blitz-2.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/rapid-blitz-3.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/rapid-blitz-3.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/rapid-blitz-3.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div> -->
        <div class="gall-ery shadow-soft">
            <div class="row">
                <div class="col-md-8">
                    <div class="widget_title inner-title gall-sys">
                        <h4>Reports</h4>
                    </div>
                </div>
            </div>
            <div class="row row-cols-1 row-cols-lg-4">
                <div class="col">
                    <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/ghraisoni-singruali-26.pdf"
                        target="blank">
                        <div class="category-icon-title shadow-inset">
                            <div class="category-title"><span class="flaticon-pdf"></span>
                                <h4> G H Raisoni Singruali 2026 </h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/signature-photos.pdf"
                        target="blank">
                        <div class="category-icon-title shadow-inset">
                            <div class="category-title"><span class="flaticon-pdf"></span>
                                <h4> Signature List</h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/singruali.pdf"
                        target="blank">
                        <div class="category-icon-title shadow-inset">
                            <div class="category-title"><span class="flaticon-pdf"></span>
                                <h4> Singruali </h4>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>

</section>
